<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <button mat-button class="save-changes" (click)="save()"
                particleAnalytics
                analyticsCategory="Save"
                analyticsAction="Save"
                [disabled]="this.editedFields.length==0">
          <i class="fas fa-check"></i> Save Changes ({{this.editedFields?.length}})
        </button>
      </div>
    </div>
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->


        <div class="content pos-relative p-0 flex flex-col full-grow-no-shrink-no-basis" *ngIf="item">

          <particle-dynamic-form-container class="particle-dynamic-form-container"
                                           [formField]="formField"
                                           [sourceType]="sourceType"
                                           [fieldConfig]="fieldConfig"
                                           [endpointName]="endpointName"
                                           [item]="item"
                                           [showOriginal]="showOriginal"
                                           [invalidateSubject]="invalidateSubject"
                                           [showLanguageOption]="showLanguageOption"
                                           [invalidateSubject]="invalidateSubject"
                                           [editedFields]="editedFields"
                                           (valueChanged)="onValueChanged($event)"
                                           (fieldSelectionChange)="onFieldSelectionChanged($event)"
                                           (selectedSectionHearderKey)="selectedSectionIndexChange($event)"
          >
          </particle-dynamic-form-container>

        </div>


      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
